'use client';

import Script from "next/script";
import { usePathname } from "next/navigation";

export default function UsercentricsScript() {
  const pathname = usePathname();
  
  if (pathname?.includes("widgets") || pathname?.includes("upgradeapp")) {
    return null;
  }

  return (
    <Script
      id="usercentrics-cmp"
      data-settings-id="CMsimVoLk"
      src="https://app.usercentrics.eu/browser-ui/latest/loader.js"
      data-tcf-enabled
      async
    />
  );
} 
